import { Button, Col, Container, Row } from 'react-bootstrap';
import { IWorkerData } from '@th-types/worker.type';
import useResumeFileDownload from '@hooks/useResumeFileDownload';
import DocViewer from '@utils/DocViewer';

interface Params {
  worker: IWorkerData;
}

export default function WorkerResume({ worker }: Params) {
  const { previewUrl, isLoading, error, download } = useResumeFileDownload(
    worker.resumeId,
    worker.resumeUrl
  );

  if (!worker.resumeId) {
    return (
      <Row className="mt-4">
        <Col md={12}>
          Worker doesn&apos;t have a resume on file, message them to ask for
          one!
        </Col>
      </Row>
    );
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col xs={12} className="d-flex justify-content-center gap-3 mb-4">
          <Button
            variant="primary"
            onClick={() => download()}
            disabled={isLoading}
            data-testid="resume-download"
          >
            Download
          </Button>
        </Col>

        {error && (
          <Col xs={12} className="text-danger text-center mb-3">
            {error}
          </Col>
        )}

        {previewUrl && (
          <DocViewer
            file={previewUrl}
            fileName={worker.resumeName}
            style={{ width: '80%', height: '70svh' }}
          />
        )}
      </Row>
    </Container>
  );
}
